











import ECharts from 'vue-echarts'
import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {
	GetDisinfectStatistics,
	GetPatientAgeStatistics,
	GetPatientSexStatistics,
	GetUserStatistics
} from "@/api/report"

@Component({
	components: {ECharts}
})
export default class Age extends AbpBase {
	loading = false
	echartsData: any = {
		tooltip: {
			trigger: 'item',
			formatter: "{a} <br/>{b}: {c} ({d}%)"
		},
		legend: {
			orient: 'vertical',
			x: 'left',
			data:[]
		},
		series: [
			{
				name:'占比',
				type:'pie',
				radius: ['50%', '70%'],
				avoidLabelOverlap: false,
				label: {
					normal: {
						show: false,
						position: 'center'
					},
					emphasis: {
						show: true,
						textStyle: {
							fontSize: '30',
							fontWeight: 'bold'
						}
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
				data:[

				]
			}
		]
	}

	data: any = []
	columns = [
		{
			title: "名称",
			key: 'type'
		},
		{
			title: "人数",
			key: 'count'
		},
		{
			title: "占比",
			key: 'ratio'
		},

	]
	created() {
		this.clearEchart()
		this.getData()
	}

	dateChange(e:any){
		this.getData()
	}

	private async getData() {
		this.loading = true
		let query:any = {}
		let res = await GetUserStatistics(query)
		this.data = res.objects
		let legendData:any = []
		let seriesData:any = []
		this.data.forEach((item:any)=>{
			legendData.push(item.type)
			seriesData.push({value:item.count, name:item.type})
		})
		this.echartsData.legend.data = legendData
		this.echartsData.series[0].data = seriesData
		this.loading = false
	}
	private clearEchart() {
		this.echartsData = {
			tooltip: {
				trigger: 'item',
				formatter: "{a} <br/>{b}: {c} ({d}%)"
			},
			legend: {
				orient: 'vertical',
				x: 'left',
				data:[]
			},
			series: [
				{
					name:'占比',
					type:'pie',
					radius: ['50%', '70%'],
					avoidLabelOverlap: false,
					label: {
						normal: {
							show: false,
							position: 'center'
						},
						emphasis: {
							show: true,
							textStyle: {
								fontSize: '30',
								fontWeight: 'bold'
							}
						}
					},
					labelLine: {
						normal: {
							show: false
						}
					},
					data:[

					]
				}
			]
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/roomInfo/person.vue